export const ssoConfig = {
  enabled: process.env.REACT_APP_SSO_ENABLED === "true",
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || "",
  scope: "openid profile email",
  enabledProviders: {
    google: true,
    microsoft: true,
    apple: false,
  },
  googleConnection: process.env.REACT_APP_GOOGLE_CONNECTION || "google-oauth2",
  microsoftConnection:
    process.env.REACT_APP_MICROSOFT_CONNECTION || "windowslive",
  appleConnection: process.env.REACT_APP_APPLE_CONNECTION || "apple",
};

export const getUserinfoUrl = () =>
  ssoConfig.domain ? `https://${ssoConfig.domain}/userinfo` : "";

export const isSSOEnabled = () =>
  ssoConfig.enabled && Boolean(ssoConfig.domain && ssoConfig.clientId);
